import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Add, ArrowBack, Done, Edit } from "@mui/icons-material";
import {
  ACTUALIZAR_TIPO_CONTACTO,
  CREAR_TIPO_CONTACTO,
} from "../graphql/mutations";
import { useMutation } from "@apollo/client";
import { MainContext } from "../../../../../Context/MainCtx";
import { CircularProgress, Stack } from "@mui/material";

export default function NuevoTipoC({
  edit,
  data,
  refetch,
  external = false,
  refetchExternal = null,
}) {
  const [open, setOpen] = React.useState(false);
  const [tipoContacto, setTipoContacto] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const { snackMessage, tokenDecoded } = React.useContext(MainContext);
  const [crearTipoContacto] = useMutation(CREAR_TIPO_CONTACTO);
  const [actualizarTipoContacto] = useMutation(ACTUALIZAR_TIPO_CONTACTO);

  const handleOpen = () => {
    setOpen(true);
    if (edit) setTipoContacto(data.tipoContacto);
  };
  const handleClose = () => {
    setOpen(false);
    setTipoContacto("");
  };

  const handleSaveTipoContacto = async (e) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      if (!tipoContacto) return;
      setLoading(true);
      if (!edit) {
        //si es nuevo
        const res = await crearTipoContacto({
          variables: {
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            tipoContacto,
          },
        });
        snackMessage({
          message: res.data.crearTipoContacto.message,
          variant: "success",
        });
      } else {
        //si va a actualizar
        const res = await actualizarTipoContacto({
          variables: {
            idTipoContacto: data._id,
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            tipoContacto,
          },
        });
        snackMessage({
          message: res.data.actualizarTipoContacto.message,
          variant: "success",
        });
      }
      if (external && refetchExternal) refetchExternal();
      if (refetch) refetch();
      setLoading(false);
      handleClose();
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      {edit ? (
        <IconButton onClick={handleOpen}>
          {loading ? <CircularProgress size={20} color="inherit" /> : <Edit />}
        </IconButton>
      ) : external ? (
        <IconButton onClick={handleOpen} size="small" color="primary">
          <Add />
        </IconButton>
      ) : (
        <Button
          onClick={handleOpen}
          color="primary"
          size="small"
          disableElevation
          sx={{ textTransform: "none" }}
          variant="contained"
          startIcon={<Add />}
        >
          Nuevo
        </Button>
      )}
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        ModalProps={{
          componentsProps: {
            backdrop: {
              sx: { background: "none" },
            },
          },
        }}
        PaperProps={{
          elevation: 1,
          sx: { width: { xs: "100vw", sm: "40vw" } },
        }}
      >
        <Toolbar variant="dense" />
        <DialogTitle>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton onClick={() => handleClose()}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" color="GrayText">
              {edit ? `Editar tipo contacto` : "Nuevo tipo contacto"}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Done />
                )
              }
              variant="contained"
              disableElevation
              size="small"
              sx={{ textTransform: "none" }}
              type="submit"
              form="formTipocontacto"
            >
              Guardar
            </Button>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ py: 0 }}>
          <form id="formTipocontacto" onSubmit={handleSaveTipoContacto}>
            <TextField
              label="Tipo"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              required
              onChange={(e) => setTipoContacto(e.target.value)}
              value={tipoContacto}
            />
          </form>
        </DialogContent>
      </Drawer>
    </div>
  );
}
